import APIService from 'services/APIService'

const api = APIService()

export const getComplianceDeepDive = bpId =>
  api.get(`/building-passport/${bpId}/compliance/deep-dive`)

export const getProgramme = bpId =>
  api.get(`/building-passport/${bpId}/compliance/programme`)

export const bulkApproveEvidence = bpId =>
  api.post(`/building-passport/${bpId}/compliance/programme/evidence/approve-all`)

export const updateProgrammeObligation = (bpId, obligationId, payload) =>
  api.patch(`/building-passport/${bpId}/compliance/programme/obligations/${obligationId}`, payload)

export const deleteProgrammeObligation = (bpId, obligationId) =>
  api.delete(`/building-passport/${bpId}/compliance/programme/obligations/${obligationId}`)

export const renameObligation = (bpId, obligationId, name) =>
  api.post(`/building-passport/${bpId}/compliance/programme/obligations/${obligationId}/rename`, { name })

export const reviewObligationEvidence = (bpId, obligationId, payload) =>
  api.post(`/building-passport/${bpId}/compliance/programme/obligations/${obligationId}/evidence-review`, payload)

export const getObligationSetup = bpId =>
  api.get(`/building-passport/${bpId}/compliance/setup`)

export const prefillObligations = bpId =>
  api.post(`/building-passport/${bpId}/compliance/setup/prefill`)

export const getSetupProgress = bpId =>
  api.get(`/building-passport/${bpId}/compliance/setup/progress`)

export const bulkUpdateObligations = (bpId, rows) =>
  Promise.all(rows.map(row => updateProgrammeObligation(bpId, row.id, row.payload)))

export const getChecklistHistory = (bpId, { days = 90 } = {}) =>
  api.get(`/building-passport/${bpId}/compliance/history`, {
    params: { days },
  })

export const getRecommendedObligationForms = (bpId, obligationId) =>
  api.get(`/building-passport/${bpId}/compliance/programme/obligations/${obligationId}/recommended-forms`)
